import React from 'react';

// Adding inline styles for simplicity
const styles = {
    container: {
        padding: '20px',
        textAlign: 'center',
        maxWidth: '600px',
        margin: '0 auto',
    },
    section: {
        marginBottom: '20px',
    },
    icon: {
        width: '30px',
        verticalAlign: 'middle',
        marginRight: '10px',
    },
    link: {
        textDecoration: 'none',
        color: '#4CAF50',
        fontSize: '18px',
    },
};

const MainContent = () => {
    return (
        <main style={styles.container}>
            <h2>Contact Information</h2>
            <p>Below are some ways to connect with me.</p>
            <p>Feel free to visit my personal website or send an email if you have any inquiries.</p>
            <div style={styles.section}>
                <img
                    src="/www-icon.png"
                    alt="Website Icon"
                    style={styles.icon}
                />
                <a
                    href="https://www.eismail.dev/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    https://eismail.dev
                </a>
            </div>
            <div style={styles.section}>
                <img
                    src="/email-icon.png"
                    alt="Email Icon"
                    style={styles.icon}
                />
                <a href="mailto:contact@e2-synergy.com" style={styles.link}>
                    contact@e2-synergy.com
                </a>
            </div>
        </main>
    );
};

export default MainContent;